import { createFileRoute, notFound } from "@tanstack/react-router"
import Cart from "@/pages/cart"

export const Route = createFileRoute("/$countryCode/cart")({
  loader: async ({ params, context }) => {
    const { countryCode } = params
    const { queryClient } = context
    const { getRegion } = await import("@/lib/data/regions")

    const region = await queryClient.ensureQueryData({
      queryKey: ["region", countryCode],
      queryFn: () => getRegion({ country_code: countryCode }),
    })

    if (!region) {
      throw notFound()
    }

    return {
      region,
      countryCode,
    }
  },
  head: () => ({
    meta: [
      { title: "Cart | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Cart,
})
